interface SectionObserverConfig {
	selector?: string;
}

export const SectionObserver = {
	elements: [] as unknown as NodeListOf<HTMLElement>,
	observer: null as IntersectionObserver | null,

	init(config?: SectionObserverConfig): void {
		const selector = config?.selector ?? '.wv-section';
		this.elements = document.querySelectorAll<HTMLElement>(selector);

		if (!this.elements.length) {
			return;
		}

		this.bindClass();
		this.bindEvents();
	},

	bindClass(): void {
		this.handleIntersect = this.handleIntersect.bind(this);
	},

	bindEvents(): void {
		this.observer = new IntersectionObserver(this.handleIntersect, {
			threshold: [0.1, 0.25, 0.5, 0.75, 0.9]
		});

		this.elements.forEach((el) => {
			this.observer?.observe(el);
		});
	},

	handleIntersect(entries: IntersectionObserverEntry[]): void {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}

			const el = entry.target as HTMLElement;
			el.classList.add('wv-section--in-view');

			this.observer?.unobserve(el);
		});
	},

};
